/**
 * Helpers de status da VPN no front.
 *
 * O servidor sincroniza o último handshake do túnel de cada peer para o banco
 * (vpn_peers.LastHandshake → DTO vpnPeerLastHandshake) em ciclos de ~1 min.
 * Um túnel vivo renova o handshake a cada ~2 min (keepalive 25s), então um
 * handshake com menos de 5 min é a evidência de "VPN conectada" — ao contrário
 * do callback de bootstrap, que chega pela internet pública e não prova túnel.
 */
export const VPN_HANDSHAKE_FRESH_MS = 5 * 60 * 1000

export function isVpnHandshakeFresh(lastHandshake, maxAgeMs = VPN_HANDSHAKE_FRESH_MS) {
  if (!lastHandshake) return false
  const t = new Date(lastHandshake).getTime()
  if (Number.isNaN(t)) return false
  return Date.now() - t < maxAgeMs
}
